import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import EmptyState from '../../../../../../Common/EmptyState.jsx';
import { Trans } from 'react-i18next';
import { P3Bold } from '../../../../../../Common/DesignSystem/Text';
import Button from '../../../../../../Common/DesignSystem/Button';
import { TabItem, Tabs } from '../../../../../../Common/DesignSystem/Tabs';
import Icon from '../../../../../../Common/DesignSystem/Icons/Icon';
import colours from '../../../../../../Common/DesignSystem/Colours';

const VehicleConditionReportsTab = (props) => {
    const [reportType, setReportType] = useState("id");
    const [reports, setReports] = useState([]);

    useEffect(() => {
        const { reports = [] } = props;
        setReports(reports);
    }, [props]);

    const returnPages = (report) => {
        let pages = "Information";

        if (report.type) {
            pages += ", In/Out"
        }

        if (report.exterior) {
            pages += ", Exterior"
        }

        if (report.interior) {
            pages += ", Interior"
        }

        if (report.accessories) {
            pages += ", Accessories"
        }

        if (report.sanitization_report) {
            pages += ", Sanitization"
        }

        return pages;
    }

    const openReport = (report) => {
        if (report.pdf_link) {
            window.open(report.pdf_link, '_blank');
        } else {
            axios.get('/ajax/vehicle/' + props.vehicle_details.vehicle.V_ID + '/ride_reports/' + report.id)
                .then(function(response) {
                    showStatusMsg("PDF Report hasn't been generated for this RideReport, it will be emailed to you once it has been generated. If you are experiencing this problem for a longer time, please contact the support team.");
                })
                .catch(function(error) {
                    showStatusMsg("There is an issue generating this RideReport, please contact the support team.");
                });

            return null;
        }
    }

    const renderTable = () => {
        if (!reports.length) {
            return (
                <tbody>
                    <tr>
                        <td colSpan = '9'><EmptyState image = "Vehicle_Reminder_Empty.svg" text = "No Ride Reports"/></td>
                    </tr>
                </tbody>
            )
        } else {
            return (
                <tbody>
                    {reports.filter(unfilteredReport => unfilteredReport[reportType] ? true : false).map((report, index) => {
                        let damages = "";

                        report.exterior_damages.map((damage, index) => {
                            if (damages !== "") {
                                damages += ", "
                            }

                            damages += damage.name
                        })

                        report.interior_damages.map((damage, index) => {
                            if (damages !== "") {
                                damages += ", "
                            }

                            damages += damage.name
                        })

                        return(
                            <tr className="ds-booking-row" style={{backgroundColor: index % 2 !== 0 ? '#F4F6F8' : 'white'}} onClick={() => openReport(report)} key={report.id}>
                                <td className="align-left" style={{paddingLeft: 20}}>
                                    <P3Bold>{moment(report.created_at).format("MMM DD YYYY, H:MM A")}</P3Bold>
                                </td>
                                <td className="align-left">
                                    <P3Bold>{report.reported_by}</P3Bold>
                                </td>
                                <td className="align-left">
                                    <P3Bold>{returnPages(report)}</P3Bold>
                                </td>
                                <td className="align-center">
                                    <span data-tip={damages}>
                                        {report.new_damage && (
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                <Icon name="NewDamage" size={24} style={{ borderRadius: '8px', border: `solid 1px ${colours.accent.error_red}`}}/>
                                            </div>
                                        )}
                                    </span>

                                </td>
                                <td className="align-center">
                                    <span>
                                        {report.damage && (
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                <Icon name="Damage" size={24} style={{ borderRadius: '8px', border: `solid 1px ${colours.accent.error_red}`}}/>
                                            </div>
                                        )}
                                    </span>
                                </td>
                                <td className="align-center">
                                    <Button primary label="View PDF" leading_ic="Show" small />
                                </td>
                            </tr>
                        )})
                    }
                </tbody>
            )
        }
    }

    return(
        <div className="row expanded bkg-white-dark">
            <div className="columns large-12 medium-12 small-12" style={{padding: '0px'}}>
                <div className="card ds-card" style={{margin: 16, padding: 16, borderRadius: 16, width: 'auto', boxShadow: '0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08)'}}>
                    <div className="overlay_block_header border-bottom">
                        <Tabs value={reportType} onChange={(e) => {setReportType(e.currentTarget.dataset.id)}}>
                            <TabItem label="All" value="id"/>
                            <TabItem label="New Damage" value="new_damage"/>
                            <TabItem label="Damage" value="damage"/>
                        </Tabs>
                    </div>
                    <div>
                        <table className = "ds-table">
                            <thead>
                                <tr className = "table-header">
                                    <th className="align-left" style = {{paddingLeft: 20, width: "200px"}}><Trans>Date</Trans></th>
                                    <th className="align-left"><Trans>By</Trans></th>
                                    <th className="align-left"><Trans>Pages</Trans></th>
                                    <th className="align-center" style = {{width: "150px"}}><Trans>New Damage</Trans></th>
                                    <th className="align-center" style = {{width: "150px"}}><Trans>Damage</Trans></th>
                                    <th className="align-center" style = {{width: "150px"}}><Trans>PDF</Trans></th>
                                </tr>
                            </thead>
                            {renderTable()}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings,
    data: store.data
})

export default connect(mapStateToProps)(VehicleConditionReportsTab)